import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import { IMAGES } from "../data/site";
import FlowerDivider from "../components/FlowerDivider";

export default function LomiLomiNui() {
  const { t } = useLang();
  useEffect(() => window.scrollTo({ top: 0 }), []);
  return (
    <main className="pt-28 md:pt-32" data-testid="lomi-page">
      <section className="py-14 md:py-20">
        <div className="container-x text-center">
          <p className="uppercase tracking-[0.3em] text-xs text-[var(--gold)]">{t.lomi.label}</p>
          <h1 className="display text-4xl sm:text-5xl md:text-7xl mt-3">{t.lomi.title}</h1>
          <FlowerDivider />
          <p className="font-serif italic text-lg md:text-2xl text-[var(--gold-dark)] max-w-2xl mx-auto">{t.lomi.sub}</p>
        </div>

        <div className="container-x max-w-3xl mt-10 md:mt-12 space-y-4 md:space-y-5 text-[16px] md:text-[17px] leading-relaxed text-[var(--ink-soft)]">
          <p>{t.lomi.p1}</p>
          <p>{t.lomi.p2}</p>
          <p>{t.lomi.p3}</p>
          <p className="font-serif italic text-[var(--ink)] text-lg md:text-xl border-l-4 border-[var(--gold)] pl-4 md:pl-5 py-1">{t.lomi.p4}</p>
        </div>

        <div className="container-x grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5 mt-10 md:mt-14">
          {[IMAGES.lomiOil1, IMAGES.lomiOil2, IMAGES.lomiOil3].map((src, i) => (
            <div key={i} className="img-mask aspect-[4/5] rounded-2xl" data-testid={`sub-lomi-oil-${i+1}`}>
              <img src={src} alt={`Tempelritual mit Ölen ${i+1}`} />
            </div>
          ))}
        </div>

        <div className="container-x text-center mt-10 md:mt-14">
          <Link to="/kontakt" className="inline-flex items-center gap-2 px-9 py-4 rounded-full bg-[var(--gold)] text-[var(--ink)] font-medium hover:bg-[var(--gold-dark)] hover:text-white transition-all">
            {t.hero.cta} <ArrowRight size={16} />
          </Link>
        </div>
      </section>
    </main>
  );
}
